<template>
  <bj-modal
    v-model="changeInquiryTimeModal.visible"
    size="auto"
    title="Change Tour Time"
  >
    <div slot="content">
      <div
        v-if="changeInquiryTimeModal.loading"
        class="text-center"
      >
        <q-spinner-puff
          color="primary"
          size="60px"
        />
      </div>
      <div
        v-else
        class="row gutter-sm"
      >
        <div class="col-12">
          <bj-unit-schedule-tour
            v-if="schedulerUnit"
            :unit="schedulerUnit"
            :is-video="isVideoSchedule"
            :assignee-id="assigneeIdForSlots"
            :disabled-datetime="disabledDatetime"
            @time-selected="onScheduleTourTimeSelected"
          />
        </div>
        <div
          v-if="changeInquiryTimeModal.payload.inquiry.lead.phone_number"
          class="col-12"
        >
          <q-field>
            <q-input
              v-model="payload.msg_to_lead"
              stack-label="SMS to lead (optional)"
            />
          </q-field>
        </div>
        <div
          v-if="changeInquiryTimeModal.payload.inquiry.tour"
          class="col-12"
        >
          <q-field>
            <q-input
              v-model="payload.msg_to_agent"
              stack-label="SMS to agent (optional)"
            />
          </q-field>
        </div>
        <div
          v-if="!changeInquiryTimeModal.payload.inquiry.unit.active_showing_profile.is_vacant"
          class="col-12"
        >
          <q-field>
            <q-input
              v-model="payload.msg_to_tenant"
              stack-label="SMS to tenant (optional)"
            />
          </q-field>
        </div>
        <div class="col-auto">
          <q-btn
            outline
            :disable="disabled || !payload.tour_at"
            label="Re-Schedule Tour"
            @click="changeScheduleTime"
          />
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import get from 'lodash.get';
import BjUnitScheduleTour from '../scheduling/bj-unit-schedule-tour.vue';

export default {
  name: 'BjChangeInquiryTimeModal',
  components: {
    BjUnitScheduleTour,
  },
  props: {
    changeInquiryTimeModal: {
      type: Object,
      required: true,
    },
  },
  data() {
    const basePayload = {
      tour_at: null,
      msg_to_lead: null,
      msg_to_agent: null,
      msg_to_tenant: null,
      allowed_to_proceed: true,
      inquiry_id: null,
    };
    return {
      base_payload: basePayload,
      payload: this.clone(basePayload),
      disabled: false,
    };
  },
  validations: {
    payload: {
      tour_at: { required },
    },
  },
  computed: {
    inquiry() {
      return get(this.changeInquiryTimeModal, 'payload.inquiry', null);
    },
    schedulerUnit() {
      if (!this.inquiry || !this.inquiry.unit_id) {
        return null;
      }
      const propertyTimezone = get(this.inquiry, 'property.timezone');
      return {
        ...get(this.inquiry, 'unit', {}),
        id: this.inquiry.unit_id,
        timezone: get(this.inquiry, 'unit.timezone') || propertyTimezone,
        property: {
          ...(get(this.inquiry, 'unit.property', {})),
          timezone: get(this.inquiry, 'unit.property.timezone') || propertyTimezone,
        },
      };
    },
    isVideoSchedule() {
      return Boolean(get(this.inquiry, 'schedule_inquiry.schedule.is_video'));
    },
    assigneeIdForSlots() {
      return get(this.inquiry, 'schedule_inquiry.schedule.tour.user_id');
    },
    disabledDatetime() {
      const currentTourAt = get(this.inquiry, 'schedule_inquiry.schedule.tour_at');
      if (!currentTourAt) {
        return null;
      }
      return this.$momentUtil(currentTourAt, null).toServerFormat();
    },
  },
  watch: {
    'payload.allowed_to_proceed': function () {
      this.payload.allowed_to_proceed = true;
    },
  },
  methods: {
    onScheduleTourTimeSelected(event) {
      this.payload.tour_at = get(event, 'time', null);
    },
    changeScheduleTime() {
      this.$v.payload.tour_at.$touch();
      if (this.$v.payload.tour_at.$invalid) {
        return;
      }

      this.disabled = true;
      this.payload.allowed_to_proceed = true;
      this.api().request('POST', `admin/inquiries/${this.changeInquiryTimeModal.payload.inquiry.id}/change-time`, this.payload)
        .then((response) => {
          if (response.success === false) {
            const restrictionMessages = []
              .concat(response.strict_restrictions || [])
              .concat(response.overrode_restrictions || []);
            this.uiNotify(restrictionMessages[0] || 'Unable to re-schedule the selected slot', 'negative');
            return;
          }
          if (response.success) {
            this.uiNotify('Tour was re-scheduled');
            this.$root.$emit('schedule-time-changed', response.inquiry);
          }
        }).catch((error) => {
          this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};

</script>

<style scoped>

</style>
